import { styled } from '@mui/material';
import { theme } from 'v3/styles/global-styles';

export const Content = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.5rem',
  alignItems: 'flex-start',
  textAlign: 'left',
  marginBottom: '2rem',

  [theme.breakpoints.up('md')]: {
    alignItems: 'flex-end',
    textAlign: 'right',
  },
}));

export const FlexContainer = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2rem',
  flexWrap: 'wrap',
}));
